import { Inject, Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ENVIRONMENT_CONFIG } from '@shared/injection-token/environment-config';
import { EnvironmentConfig } from '@shared/interfaces/environment-config';

@Injectable()
export class ApiSecretInterceptor implements HttpInterceptor {
  constructor(@Inject(ENVIRONMENT_CONFIG) private environmentConfig: EnvironmentConfig) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (this.environmentConfig.api.secret) {
      request = request.clone({
        setHeaders: { 'X-ApiSecretHeader': this.environmentConfig.api.secret },
      });
    }

    return next.handle(request);
  }
}
